import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, NavLink } from "react-router-dom";
import { post, put } from '../../utils/api';
import { Form, FormLine, FormItem, FormInput } from '../common/Form';
import StickerDelete from './StickerDelete';
//
// Компонент для создания и редактирования стикера мероприятия
//
const StickerForm = ({ event, sticker }) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [ textRu, setTextRu ] = useState(sticker ? sticker.text.ru : '');
	const [ textEn, setTextEn ] = useState(sticker ? sticker.text.en : '');
    const [ color, setColor ] = useState(sticker ? sticker.color : '#ffffff');
    const [ background, setBackground ] = useState(sticker ? sticker.background : '#ff0000');
    const [ priority, setPriority ] = useState(sticker ? sticker.priority + '' : '1');
    const [ success, setSuccess ] = useState('');
    const [ isSaving, setIsSaving ] = useState(false);
    const [ saveError, setSaveError ] = useState('');

    // Отправка данных
	const onSubmit = async () => {
        setIsSaving(true);
        setSaveError('');
        setSuccess('');

        const data = {
            text_ru: textRu,
            text_en: textEn,
            color,
            background,
            priority,
            event: event._id,
        };

        let result;
        if(sticker) {
            result = await put('/stickers/' + sticker._id, data);
        } else {
            result = await post('/stickers', data);
        }

        if(result.error) {
            setSaveError(result.error);
        } else {
            setSuccess(sticker ? 'sticker.editsuccess' : 'sticker.addsuccess');
			navigate('/cabinet/eventview/' + event._id + '/action/updated');
        }
        setIsSaving(false);
	};

    return (
		<div>
			{isSaving ? <span>{t('common.loading')}</span> :
			<Form
                success={success}
                error={saveError}
                wide={true}
                submit={sticker ? t('sticker.editsubmit') : t('sticker.addsubmit')}
                onSubmit={onSubmit}
            >
                {/* Текст стикера */}
				<FormLine>
                    <FormItem>
                        <FormInput
                            id='textRu'
                            type='text'
                            value={textRu}
                            onChange={setTextRu}
                            placeholder={t('sticker.text_ru')}
                            className='lang-ru'
                            required={true}
                            label={t('sticker.text_ru')}
                        />
                    </FormItem>
                    <FormItem>
                        <FormInput
                            id='textEn'
                            type='text'
                            value={textEn}
                            onChange={setTextEn}
                            placeholder={t('sticker.text_en')}
                            className='lang-en'
                            required={true}
                            label={t('sticker.text_en')}
                        />
                    </FormItem>
                </FormLine>
                {/* Цвета */}
				<FormLine>
                    <FormItem>
                        <FormInput
                            id='color'
                            type='text'
                            value={color}
                            onChange={setColor}
                            placeholder={t('sticker.color')}
                            label={t('sticker.color')}
                        />
                    </FormItem>
                    <FormItem>
                        <FormInput
                            id='background'
                            type='text'
                            value={background}
                            onChange={setBackground}
                            placeholder={t('sticker.background')}
                            label={t('sticker.background')}
                        />
                    </FormItem>
                </FormLine>
                {/* Приоритет */}
				<FormLine>
                    <FormItem>
                        <FormInput
                            id='priority'
                            type='text'
                            value={priority}
                            onChange={setPriority}
                            placeholder={t('sticker.priority')}
                            label={t('sticker.priority')}
                        />
                    </FormItem>
                </FormLine>
			</Form>}

            {sticker && <StickerDelete event_id={event._id} sticker_id={sticker._id}/>}

            <p>
                <NavLink to={'/cabinet/eventview/' + event._id}>{t('sticker.back')}</NavLink>
            </p>
		</div>
	);
};

export default StickerForm;
